import React from "react";
import CardP from "./Card";

const CardList = ({ portfolioData }) => {
  return (
    <div className="cardList">
      {portfolioData.map((portfolio) => (
        <CardP
          key={portfolio.id}
          name={portfolio.name}
          description={portfolio.description}
          img={portfolio.img}
          url={portfolio.url}
        />
      ))}
    </div>
  );
};

export default CardList;
